
export const GetWarehouses = (api) => {
    return api.get(`/api/v1/Warehouse/getWarehouses`);
}

export const GetWarehouseByZipCode = (api, zipCode) => {
    return api.get(`/api/v1/Warehouse/getWarehouseByZipCode?zipCode=${zipCode}`)
}

export const GetMacroRegionalWarehouseByRegionalWhId = (api, regionalWhId) => {
    return api.get(`/api/v1/Warehouse/getMacroRegionalWarehouseByRegionalWhId?regionalWhId=${regionalWhId}`)
}

export const GetMacroRegionalWarehouseBySiteId = (api, siteId) => {
    return api.get(`/api/v1/Warehouse/getMacroRegionalWarehouseBySiteId?siteId=${siteId}`)
}